export const DRAFT_TABS = [
  { tab: 'types', permission: 'de_can_view_types' },
  { tab: 'witnesses', permission: 'de_can_view_witnesses' },
  { tab: 'models', permission: 'de_can_view_drafts' },
  { tab: 'bonds', permission: 'de_can_view_bonds' },
  { tab: 'variables', permission: 'de_can_view_variables' },
] as const;

export type DraftTab = typeof DRAFT_TABS[number]['tab'];

export const DRAFTS_PAGE_URL = '/app/drafts';

export function isDraftTab(value: string | null | undefined): value is DraftTab {
  return DRAFT_TABS.some((item) => item.tab === value);
}

export function draftsTabUrl(tab: DraftTab): string {
  return `${DRAFTS_PAGE_URL}?tab=${tab}`;
}
